export const CAROUSEL_MOBILE_MAX_WIDTH_PX = 767;

export function isCarouselMobileViewport(): boolean {
  return (
    typeof window !== 'undefined' &&
    window.matchMedia(`(max-width: ${CAROUSEL_MOBILE_MAX_WIDTH_PX}px)`).matches
  );
}
